<template>
  <div class="c-event-attributes">
    <div class="c-event-attributes__card">
      <settings-header title="Параметры события" />
      <div class="c-event-attributes__controls">
        <el-button
          class="r-button"
          type="success"
          @click="save"
          :disabled="isSaveDisabled"
        >
          {{ activeEventId === "new" ? "Создать событие" : "Обновить событие" }}
        </el-button>
      </div>
      <div class="c-event-attributes__container">
        <ul class="c-event-attributes__list">
          <li
            class="ee-card-attribute"
            v-for="config in attributes"
            :key="config.prop"
          >
            <component
              :is="`card-${config.type}`"
              :feature="feature"
              :config="config"
            />
          </li>
        </ul>
      </div>
    </div>
    <settings-close-button @close="closePanel" />
  </div>
</template>

<script>
import {
  clearAllHelpers,
  removeStopPointsHelpers,
  clearAllRouteGeometry
} from "@/libs/map-draw/helpers";
import { getPrimaryAttributes } from "@/components/event-editor/components/active-card/config";
import CardDatetime from "@/components/event-editor/components/active-card/controls/card-datetime";
import CardInput from "@/components/event-editor/components/active-card/controls/card-input";
import CardInputNumber from "@/components/event-editor/components/active-card/controls/card-input-number";
import CardSelect from "@/components/event-editor/components/active-card/controls/card-select";
import SettingsHeader from "../settings-header/settings-header";
import SettingsCloseButton from "../settings-header/settings-close";

export default {
  components: {
    SettingsHeader,
    SettingsCloseButton,
    CardDatetime,
    CardInput,
    CardInputNumber,
    CardSelect
  },
  data() {
    return {
      draw: this.$cControllers.editor.parent.draw,
      attributes: getPrimaryAttributes(
        this.$store.state.calculations.model.ids
      ),
      feature: {
        id: null,
        event_class_id: null,
        start_time: null,
        end_time: null,
        closed_line_count: 0
      },
      requiredProps: ["closed_line_count", "event_class_id"]
    };
  },
  computed: {
    activeEventId() {
      return this.$store.state.calculations.activeEventId;
    },
    state() {
      return this.$store.state.calculations.editorState;
    },
    ids() {
      return this.$store.state.calculations.model.ids;
    },
    isSaveDisabled() {
      return this.requiredProps.some(p => !this.feature[p]);
    }
  },
  watch: {
    activeEventId() {
      this.setInitialValues();
    }
  },
  methods: {
    closePanel() {
      this.$cControllers.drawContext.deselect(this.activeEventId);

      this.$store.commit("SET_CALC_FIELD", {
        field: "activeEventId",
        value: null
      });
      this.$store.commit("SET_CALC_FIELD", {
        field: "overlay",
        value: false
      });
    },
    cancel() {
      const { activeObject, mode } = this.state;

      if (mode === "create") {
        this.draw.delete(activeObject.id);
        this.state.isDrawing = false;
      }
      if (mode === "edit") this.draw.changeMode("simple_select");

      clearAllHelpers(this.mapgl);
      removeStopPointsHelpers(this.mapgl);
      clearAllRouteGeometry(this.mapgl);
      this.closePanel();

      this.state.activeObject = null;
    },
    save() {
      const {
        activeObject,
        editingCallback,
        creatingCallback,
        mode
      } = this.state;
      const callback = mode === "create" ? creatingCallback : editingCallback;

      this.attributes.forEach(({ prop }) => {
        activeObject.setProperty(prop, this.feature[prop]);
      });

      callback(activeObject);
      this.closePanel();

      this.$store.commit("SET_CALC_FIELD", {
        field: "isEdited",
        value: true
      });
    },
    escapeHandler(e) {
      const { key } = e;

      if (key === "Escape") this.closePanel();
    },
    setInitialValues() {
      const { activeObject } = this.state;

      Object.keys(this.feature).forEach(key =>
        this.$set(this.feature, key, activeObject.properties[key])
      );
    }
  },
  created() {
    this.setInitialValues();

    window.addEventListener("keydown", this.escapeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.escapeHandler);
  }
};
</script>

<style lang="scss">
.c-event-attributes {
  position: relative;
  height: calc(100vh - 48px);

  &__card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &__controls {
    padding: 8px;
    border-bottom: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;

    .r-button {
      width: 100%;
    }
  }

  &__container {
    flex: 1;
    padding: 8px;
  }
}
</style>
